document.addEventListener('DOMContentLoaded', () => {
  // Variants on Collection clone la carte d'un produit pour chacune de ses
  // variantes en ne changeant que l'image, le titre, le prix et le lien : la
  // vidéo copiée est celle de la variante rendue par Liquid. On remet la bonne
  // vidéo d'après le ?variant= du lien, à partir du JSON embarqué par
  // tdm-card-product.liquid.
  function getCardVariantId(card) {
    const link = card.querySelector('[data-product-link]') || card.querySelector('a[href*="variant="]');
    if (link) {
      const id = new URL(link.href, window.location.origin).searchParams.get('variant');
      if (id) return id;
    }
    const input = card.querySelector('[data-variant-id]');
    return input ? input.value : null;
  }

  const parsedVideos = new WeakMap();
  function syncVariantVideo(wrapper, video) {
    const data = wrapper.querySelector('[data-variant-videos]');
    const card = wrapper.closest('.card-wrapper');
    if (!data || !card) return;
    const variantId = getCardVariantId(card);
    if (!variantId) return;

    let videos = parsedVideos.get(data);
    if (!videos) {
      try {
        videos = JSON.parse(data.textContent);
      } catch (e) {
        return;
      }
      parsedVideos.set(data, videos);
    }
    const entry = videos[variantId];
    if (!entry || !entry.sources.length) return;

    // video_tag rend des URL relatives (/cdn/shop/videos/…), le JSON des URL
    // en //domaine/cdn/shop/videos/… : on compare le chemin du fichier.
    const fileKey = (url) => (url || '').split('/videos/')[1]?.split('?')[0];
    const current = video.querySelector('source');
    if (current && fileKey(current.getAttribute('src')) === fileKey(entry.sources[0].url)) return;

    video.querySelectorAll('source').forEach((source) => source.remove());
    entry.sources.forEach(({ url, type }) => {
      const source = document.createElement('source');
      source.src = url;
      if (type) source.type = type;
      video.appendChild(source);
    });
    if (entry.poster) video.poster = entry.poster;
    video.load();
  }

  function getWrapperVideo(wrapper) {
    const video = wrapper && wrapper.querySelector('video');
    if (video) syncVariantVideo(wrapper, video);
    return video;
  }

  function getVideo(card) {
    return getWrapperVideo(card.querySelector('[data-card-hover-video]'));
  }

  function getBentoVideo() {
    if (!window.matchMedia('(min-width: 750px)').matches) return null;
    return getWrapperVideo(document.querySelector('#product-grid > .grid__item:nth-child(3) [data-card-hover-video]'));
  }

  function playBentoVideo() {
    const video = getBentoVideo();
    if (video) video.play().catch(() => {});
  }

  // Écouteurs délégués sur document (pointerover/pointerout bulle, contrairement
  // à mouseenter/mouseleave) : ça marche aussi pour les cartes réinjectées après
  // un filtre de collection, quand facets.js remplace #ProductGridContainer en
  // innerHTML — un écouteur posé une seule fois sur les cartes d'origine, lui,
  // ne suivrait pas les nouvelles cartes.
  document.addEventListener('pointerover', (e) => {
    const card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    const video = getVideo(card);
    if (!video) return;
    video.currentTime = 0;
    video.play().catch(() => {});
  });

  document.addEventListener('pointerout', (e) => {
    const card = e.target.closest && e.target.closest('.card-wrapper');
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) {
      const video = getVideo(card);
      if (video) video.pause();
    }

    // La carte "bento" (3e produit de #product-grid) affiche son état survolé
    // en permanence : survoler une autre carte la met en pause au passage,
    // mais elle doit reprendre dès qu'on ne survole plus aucun produit.
    const stillOnACard = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.card-wrapper');
    if (!stillOnACard) playBentoVideo();
  });

  // Les vidéos sont rendues en preload="none" (une vidéo différente par
  // variante = un fichier par carte). Sur les appareils qui survolent, on ne
  // précharge les métadonnées que des cartes proches de l'écran, pour que le
  // premier survol démarre vite ; sur tactile, la vidéo n'est jamais affichée
  // donc rien n'est chargé.
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const warmObserver =
    canHover && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              getWrapperVideo(entry.target.closest('[data-card-hover-video]'));
              entry.target.preload = 'metadata';
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  // WeakSet plutôt qu'un attribut : un attribut serait recopié sur les cartes
  // clonées par Variants on Collection, qui ne seraient alors jamais observées.
  const warmed = new WeakSet();
  function warmVideos() {
    if (!warmObserver) return;
    document.querySelectorAll('[data-card-hover-video] video').forEach((video) => {
      if (warmed.has(video)) return;
      warmed.add(video);
      warmObserver.observe(video);
    });
  }

  warmVideos();
  playBentoVideo();

  // Un filtre de collection remplace #ProductGridContainer entièrement : la
  // carte bento est reconstruite avec une vidéo à l'arrêt, il faut donc la
  // relancer à chaque fois que la grille est réinjectée (et observer les
  // nouvelles vidéos).
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && 'MutationObserver' in window) {
    new MutationObserver(() => {
      warmVideos();
      playBentoVideo();
    }).observe(gridContainer, { childList: true, subtree: true });
  }
});
